import withTitle from './withTitle';

export { withTitle };
